import { useInfiniteQuery, useQuery } from 'react-query';
import { fetcher } from '../../client'
import { fetchPublicTemplateList, fetchFeaturedPublicTemplate, fetchPublicTemplate, fetchLawyerList } from '../../actions/templates'

export function useInfinitePublicTemplateList(params, options) {
  return useInfiniteQuery(['public-templates', params], ({ pageParam = 1 }) => fetcher(fetchPublicTemplateList({ ...params, page: pageParam })), {
    // keepPreviousData: true,
    ...options,
  })
}

export function usePublicTemplateList(params, options) {
  return useQuery(['public-templates', params], () => fetcher(fetchPublicTemplateList(params)), options)
}

export function usePublicPlaylistList(params, options) {
  return useQuery(['public-playlists', params], () => fetcher(fetchPublicTemplateList({ ...params, isPlaylist: true })), options)
}

export function useFetchFeaturedPublicTemplate(params, options) {
  return useQuery(['featured-public-template', params], () => fetcher(fetchFeaturedPublicTemplate(params)), options)
}
export function useFetchPublicTemplate(publicTemplateId, params = {}, options) {
  return useQuery(['public-template', publicTemplateId, params], () => fetcher(fetchPublicTemplate(publicTemplateId, params.hasAccount)), options)
}

export function useFetchLawyerList(params = {}, options) {
  return useQuery(['lawyers', params], () => fetcher(fetchLawyerList(params)), options)
}